<template>
  <div class="document-card">
    <div class="tags">
      <div class="tag">
        <span>{{computeTime()}}</span>
      </div>
    </div>
    <div class="content-wrap">
      <div class="left">
        <img :src="content.pictures[0]" />
      </div>
      <div class="right">
        <p class="title" :title="content.name">{{content.name}}</p>
        <div class="text">
          <span>{{content.service}}</span>
        </div>
        <div class="count">
          <span class="old-price">¥{{content.market_price}}</span>
          <span>{{content.user_count}}人购买</span>
        </div>
        <div class="price">
          <span class="new-price">¥{{content.price}}</span>
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="menu-item" @click="handleToRestore">
        <i class="el-icon-refresh-left"></i>
        <span>还原</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToClone">
        <i class="el-icon-document-copy"></i>
        <span>克隆</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
import { materialRemove, materialRestore, materialClone } from '@/api/material'
import { formatTime } from '@/utils/helper'

export default {
  name: "document-card",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 倒计时计算
    computeTime() {
      if (!this.content.update_time) { return '' }
      const time = this.$moment(this.content.update_time).add(30, 'days').valueOf()  - Date.now()
      return formatTime(time/1000)
    },
    // 还原
    handleToRestore() {
      // 二次确认
      this.$confirm('确定要还原吗？', '提示', {
        type: 'warning'
      }).then(() => {
        materialRestore({id: this.content.id}).then(res => {
          this.$message.success(`还原成功，请在内容管理中查看`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
    // 克隆
    handleToClone() {
      // 二次确认
      this.$confirm('确定要克隆吗？', '提示', {
        type: 'warning'
      }).then(() => {
        materialClone({id: this.content.id}).then(res => {
          this.$message.success(`克隆成功，请在内容管理中查看`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
    // 删除
    handleToRemove() {
      // 二次确认
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        materialRemove({id: this.content.id}).then(res => {
          this.$message.success(`删除成功`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
  },
};
</script>

<style lang="less" scoped>
.document-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 30px 10px 0px;
  overflow: hidden;

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409EFF;
      }
    }
  }

  a {
    text-decoration: none;
    color: #303133;
  }

  .content-wrap {
    display: flex;

    .left {
      margin-right: 10px;
    }
    .right {
      flex: 1;
      overflow: hidden;
    }
    img {
      width: 90px;
      height: 90px;
      object-fit: cover;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .text {
      margin-top: 5px;
      font-size: 12px;
      color: #669900;

      span:not(:first-child) {
        margin-left: 5px;
      }
    }
    .count {
      margin-top: 10px;
      font-size: 12px;

      span:not(:first-child) {
        margin-left: 5px;
      }
    }
    .old-price {
      text-decoration: line-through;
      color: #999;
    }
    .new-price {
      margin-top: 2px;
      color: #f00;
    }
    .price {
      margin-top: 10px;
      font-weight: bold;
    }
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    margin: 10px -10px 0;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
